import { CHARACTER_ACTIONS } from "@/character/actions";
import {
  GRID_COLUMNS,
  SHEET_COLUMNS,
  sheetLayoutFromImage,
  normalizeGridSpec,
} from "@/character/grid";
import type { CharacterProfile } from "@/character/storage";
import {
  drawGridSheet,
  drawRowStrip,
  startRowLoop,
} from "@/character/sheet-preview-canvas";

const SHEET_MAX_WIDTH = 520;

export function mountCharacterGridShowcase(
  host: HTMLElement,
  profile: CharacterProfile,
): () => void {
  const cleanups: Array<() => void> = [];

  host.innerHTML = `
    <section class="character-grid-panel" aria-labelledby="grid-panel-title">
      <div class="grid-panel-head">
        <h2 id="grid-panel-title" class="grid-panel-title">กริดสไปรต์ชีต</h2>
        <p class="hint grid-panel-meta">กำลังโหลด…</p>
      </div>
      <canvas class="grid-sheet-canvas" aria-label="ภาพรวมสไปรต์ชีตพร้อมเส้นกริด"></canvas>
      <div class="grid-loop-list"></div>
    </section>
  `;

  const metaEl = host.querySelector<HTMLElement>(".grid-panel-meta");
  const sheetCanvas = host.querySelector<HTMLCanvasElement>(".grid-sheet-canvas");
  const loopList = host.querySelector<HTMLElement>(".grid-loop-list");

  const img = new Image();
  img.decoding = "async";

  const onLoad = () => {
    const layout = sheetLayoutFromImage(img);
    const grid = normalizeGridSpec(layout.grid);

    if (metaEl) {
      const colLabel =
        grid.sheetColumns === SHEET_COLUMNS
          ? `${SHEET_COLUMNS} คอลัมน์ (1 ป้าย + ${GRID_COLUMNS} เฟรม)`
          : `${grid.sheetColumns} คอลัมน์ (สไปรต์ล้วน)`;
      metaEl.textContent = `${colLabel} × ${grid.rows} แถว · ${layout.sheetWidth}×${layout.sheetHeight} px · ${grid.frameWidth}×${grid.frameHeight} ต่อช่อง`;
    }

    if (sheetCanvas) {
      drawGridSheet(sheetCanvas, img, layout, SHEET_MAX_WIDTH);
    }

    if (loopList) {
      loopList.replaceChildren();
      for (const action of CHARACTER_ACTIONS) {
        const rowEl = document.createElement("article");
        rowEl.className = "grid-loop-row";
        rowEl.innerHTML = `
          <span class="grid-loop-label">${action.templateLabel}</span>
          <div class="grid-loop-body">
            <canvas class="grid-row-strip" aria-hidden="true"></canvas>
            <canvas class="grid-loop-player" role="img" aria-label="${action.label} แอนิเมชัน loop"></canvas>
          </div>
        `;
        loopList.append(rowEl);

        const strip = rowEl.querySelector<HTMLCanvasElement>(".grid-row-strip");
        const player = rowEl.querySelector<HTMLCanvasElement>(".grid-loop-player");
        if (strip) drawRowStrip(strip, img, layout, action.row);
        if (player) cleanups.push(startRowLoop(player, img, layout, action.row));
      }
    }
  };

  img.onload = onLoad;
  img.onerror = () => {
    if (metaEl) metaEl.textContent = "";
    const err = document.createElement("p");
    err.className = "form-error";
    err.textContent = "โหลดสไปรต์ชีตไม่สำเร็จ";
    host.querySelector(".grid-panel-head")?.append(err);
  };
  img.src = profile.spritesheetDataUrl;

  return () => {
    for (const stop of cleanups) stop();
    host.replaceChildren();
  };
}
